import { createFileRoute, useLoaderData } from "@tanstack/react-router";

import { ContactDetailPanel } from "@/features/contacts/contact-detail-panel";

export const Route = createFileRoute("/contacts/$contactId")({
  component: ContactDetailRoute
});

/**
 * 一覧の上に重ねて開く詳細。URL を持つので共有・再現ができ、
 * 閉じると一覧のスクロール位置と絞り込みがそのまま残る（段階的開示・原則 2）。
 */
function ContactDetailRoute() {
  const { contactId } = Route.useParams();
  const navigate = Route.useNavigate();
  const data = useLoaderData({ from: "/contacts" });

  const contact = data.contacts.find((entry) => entry.id === contactId);

  return (
    <ContactDetailPanel
      contact={contact}
      onClose={() => void navigate({ to: "/contacts", search: (previous) => previous })}
    />
  );
}
